export default "__VITE_ASSET__BYnS0oTe__"